import httpService from "..";

export const searchGroupClaimsApi = async (groupId: string, search: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/claim/group/${groupId}/search?search=${search}`,
    "get"
  );
};

export const getClaimApi = async (id: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/claim/${id}`,
    "get"
  );
};

export const getCompanyClaimsApi = async (groupId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/claim/group/${groupId}`,
    "get"
  );
};

export const addClaimApi = async (
  data: {},
  userId: number,
  groupId: number
) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/claim?userId=${userId}&groupId=${groupId}`,
    "post",
    data
  );
};

export const addExternalClaimApi = async (
  data: {},
  userId: number,
  groupId: number
) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/claim/external?userId=${userId}&groupId=${groupId}`,
    "post",
    data
  );
};

export const addClaimNoteApi = async (
  id: string,
  data: {},
  userId: number,

) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/claim/note/${id}?userId=${userId}`,
    "post",
    data
  );
};

export const approveClaimApi = async (id: string, data: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/claim/approve/${id}`,
    "post",
    data
  );
};

export const rejectClaimApi = async (id: string, data: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/claim/reject/${id}`,
    "post",
    data
  );
};

export const paidClaimApi = async (id: string, data: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/claim/paid/${id}`,
    "post",
    data
  );
};

export const closeClaimApi = async (id: string, data: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/claim/close/${id}`,
    "post",
    data
  );
};

export const editClaimApi = async (id: string, data: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/claim/${id}`,
    "patch",
    data
  );
};

/** Append claim documents without updating claim fields. POST /claim/:claimId/document */
export const addClaimDocumentApi = async (claimId: string, data: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/claim/${claimId}/document`,
    "post",
    data
  );
};
